<template>
  <dashboard-topbar/>
  <div class="main">
    <div class="mainContent">
      <div class="container">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-2 col-sm-2 col-2 pr-0">
            <dashboard-navbar/>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-10 col-sm-10 col-10 pl-0">
            <div class="cabinet-content">
              <dashboard-order-single/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardTopbar from "@/components/Topbar.vue";
import DashboardNavbar from "@/components/Navbar.vue"
import DashboardOrderSingle from "@/components/OrderSingle.vue"

export default {
  name: 'OrderApp',
  props: {
    msg: String,
  },
  components: {
    DashboardTopbar,
    DashboardNavbar,
    DashboardOrderSingle
  },
  data(){
    return{
      logoUser: require('@/assets/svg/person-circle.svg'),
      logoCard: require('@/assets/svg/card-list.svg'),
      logoHeart: require('@/assets/svg/suit-heart.svg'),
      logoCash: require('@/assets/svg/cash-coin.svg'),
      logoEye: require('@/assets/svg/eye.svg'),
      logoComment: require('@/assets/svg/chat-left-text.svg')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";

  .pr-0{
    padding-right: 0;
  }
  .pl-0{
    padding-left: 0;
  }

  .main {
    margin-top: 86px;

    &Content {
      margin-top: 0;
    }

    .cabinet-content{
      min-height: 100vh;
      padding-left: 40px;
      border-left: 1px solid #e9e9e9;
      overflow: hidden;
      @media only screen and (max-width: $max-width-tablet) {
        padding-left: 12px;
      }
    }
  }
</style>
